module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body clinic-doctor-wrapper"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.doctors.title')))]), _vm._v(" "), (!_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.enterCreateMode($event)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('action_message.add')))]) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('button', {
    staticClass: "add-service btn btn-info",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAddPanel = !_vm.showAddPanel
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.list')))]) : _vm._e()]), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "doctor-wrapper"
  }, [(!_vm.isStepPrcess) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [(!_vm.isStepPrcess) ? _c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.doctors.search_doctor')
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('multiselect', {
    attrs: {
      "id": "specialty_filter",
      "placeholder": _vm.$t('message.doctors.filter_specialty'),
      "options": _vm.specialty_filters,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_specialty_filters),
      callback: function($$v) {
        _vm.selected_specialty_filters = $$v
      },
      expression: "selected_specialty_filters"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('multiselect', {
    attrs: {
      "id": "subspecialty_filter",
      "placeholder": _vm.$t('message.doctors.filter_subspecialty'),
      "options": _vm.subspecialty_filters,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_subspecialty_filters),
      callback: function($$v) {
        _vm.selected_subspecialty_filters = $$v
      },
      expression: "selected_subspecialty_filters"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isStepPrcess) ? _c('div', {
    staticClass: "pagination"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.show')))]), _vm._v(" " + _vm._s(_vm.paginator.from) + " - " + _vm._s(_vm.paginator.to) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.pagination.from')))]), _vm._v(" " + _vm._s(_vm.paginator.total) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('message.doctors.doctor_unit')))])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.prev_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.prev_page_url && _vm.refreshDoctorList(_vm.paginator.prev_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.prev')))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    class: {
      enable: _vm.paginator.next_page_url
    },
    on: {
      "click": function($event) {
        _vm.paginator.next_page_url && _vm.refreshDoctorList(_vm.paginator.next_page_url)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.pagination.next')))])]) : _vm._e(), _vm._v(" "), (_vm.doctors.length > 0) ? _c('div', _vm._l((_vm.doctor_list), function(d, index) {
    return _c('div', {
      key: d,
      staticClass: "doctor-container"
    }, [_c('div', {
      staticClass: "doctor-content",
      on: {
        "click": function($event) {
          _vm.editDoctor(d)
        }
      }
    }, [_c('h6', [_vm._v(_vm._s((_vm.$i18n.locale === 'th') ? d.name_th : d.name_en))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(d.specialities[0] && ((_vm.$i18n.locale === 'th') ? d.specialities[0].name_th : d.specialities[0].name_en)) + " : " + _vm._s(_vm.display_sub_specialities(d)))])]), _vm._v(" "), _c('div', {
      staticClass: "doctor-actions"
    }, [_c('a', {
      attrs: {
        "href": _vm.$APP_CONFIG.api.domain + '/doctor/d-' + d.id,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" "), (!_vm.$ismobile()) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('action_message.view')))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "doctor-actions"
    }, [_c('i', {
      staticClass: "fa fa-qrcode",
      on: {
        "click": function($event) {
          _vm.showQRCode(d)
        }
      }
    }), _vm._v(" "), (!_vm.$ismobile()) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('message.doctors.qr_code')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "doctor-actions"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      on: {
        "click": function($event) {
          _vm.editDoctor(d)
        }
      }
    }), _vm._v(" "), (!_vm.$ismobile()) ? _c('div', [_c('small', [_vm._v(_vm._s(_vm.$t('action_message.edit')))])]) : _vm._e()])])
  })) : _c('h6', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.doctors.no_doctor')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.showAddPanel) ? _c('div', {
    staticClass: "doctor-form"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctors.name_th')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('bs-input', {
    staticClass: "prefix-name remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.prefix'),
      "placeholder": _vm.$t('message.doctors.prefix')
    },
    model: {
      value: (_vm.doctor.th.prefix),
      callback: function($$v) {
        _vm.doctor.th.prefix = $$v
      },
      expression: "doctor.th.prefix"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['th.prefix']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.firstname'),
      "placeholder": _vm.$t('message.doctors.firstname')
    },
    model: {
      value: (_vm.doctor.th.firstname),
      callback: function($$v) {
        _vm.doctor.th.firstname = $$v
      },
      expression: "doctor.th.firstname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['th.firstname']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  })], 1)]), _vm._v(" "), _c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.lastname'),
      "placeholder": _vm.$t('message.doctors.lastname')
    },
    model: {
      value: (_vm.doctor.th.lastname),
      callback: function($$v) {
        _vm.doctor.th.lastname = $$v
      },
      expression: "doctor.th.lastname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['th.lastname']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.doctors.name_en')))]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', [_c('bs-input', {
    staticClass: "prefix-name remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.prefix'),
      "placeholder": _vm.$t('message.doctors.prefix')
    },
    model: {
      value: (_vm.doctor.en.prefix),
      callback: function($$v) {
        _vm.doctor.en.prefix = $$v
      },
      expression: "doctor.en.prefix"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['en.prefix']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.firstname'),
      "placeholder": _vm.$t('message.doctors.firstname')
    },
    model: {
      value: (_vm.doctor.en.firstname),
      callback: function($$v) {
        _vm.doctor.en.firstname = $$v
      },
      expression: "doctor.en.firstname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['en.firstname']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  })], 1)]), _vm._v(" "), _c('bs-input', {
    staticClass: "remove-margin-bottom",
    attrs: {
      "label": _vm.$t('message.doctors.lastname'),
      "placeholder": _vm.$t('message.doctors.lastname')
    },
    model: {
      value: (_vm.doctor.en.lastname),
      callback: function($$v) {
        _vm.doctor.en.lastname = $$v
      },
      expression: "doctor.en.lastname"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError['en.lastname']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.doctors.gender')))]), _vm._v(" "), _c('div', {
    staticClass: "gender-select"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.gender),
      expression: "doctor.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio1",
      "value": "m"
    },
    domProps: {
      "checked": _vm._q(_vm.doctor.gender, "m")
    },
    on: {
      "__c": function($event) {
        _vm.doctor.gender = "m"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-male fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.doctors.male')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.gender),
      expression: "doctor.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2",
      "value": "f"
    },
    domProps: {
      "checked": _vm._q(_vm.doctor.gender, "f")
    },
    on: {
      "__c": function($event) {
        _vm.doctor.gender = "f"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-female fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.doctors.female')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('message.doctors.specialty')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctors.specialty')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "speciality",
      "placeholder": _vm.$t('message.doctors.specialty_placeholder'),
      "options": _vm.select_specialties_options,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_specialities),
      callback: function($$v) {
        _vm.selected_specialities = $$v
      },
      expression: "selected_specialities"
    }
  }), _vm._v(" "), _c('error-box', {
    attrs: {
      "message": _vm.frmError.specialities
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctors.subspecialty')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "multi-select-form",
    attrs: {
      "id": "subspeciality",
      "placeholder": _vm.$t('message.doctors.subspecialty_placeholder'),
      "options": _vm.sub_specialities,
      "multiple": true,
      "hide-selected": true,
      "allow-empty": true,
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.selected_sub_specialities),
      callback: function($$v) {
        _vm.selected_sub_specialities = $$v
      },
      expression: "selected_sub_specialities"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": _vm.cancelAddingDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": _vm.addDoctor
    }
  }, [_vm._v(_vm._s(_vm.editMode ? _vm.$t('action_message.edit') : _vm.$t('action_message.add')))]), _vm._v(" "), (_vm.editMode) ? _c('button', {
    staticClass: "btn btn-add btn-lg btn-danger remove-doctor-action",
    on: {
      "click": _vm.removeDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (!_vm.showAddPanel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.cancelChange
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), _vm._t("loader")], 2)]) : _vm._e()])]), _vm._v(" "), _c('sweet-modal', {
    ref: "qrCodeModal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-qrcode', {
    attrs: {
      "id": "doctorQrCanvas",
      "value": _vm.doctorQrUrl,
      "options": {
        size: 200
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.downloadDoctorQr
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.download_qr_code')))]), _vm._v(" "), _c('a', {
    ref: "doctorQrLink"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    attrs: {
      "href": _vm.doctorQrUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.doctorQrUrl) + "\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53d752d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/steps/Doctors.vue
// module id = 1011
// module chunks = 1